import React from 'react';
import numeral from 'numeral';
import { Grid, Typography, Link, Button } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import { get, keys, values } from 'lodash/object';
import { map, forEach } from 'lodash/collection';
import { flow } from 'lodash';
// import { startCase } from 'lodash/string';
import { startCase } from 'helpers/lang';
import { isEmpty } from 'lodash/lang';
import { compact } from 'lodash/array';
import { isBoolean } from 'lodash/lang';
import NoticeBox from 'components/NoticeBox';
import pdfBahQarLink from 'static/pdf/ZurichMedicalProvidersBahrainAndQatar.pdf';
import pdfUaeLink from 'static/pdf/ZurichMedicalProvidersUae.pdf';
import { api } from 'environments';

import Dialog from 'components/CustomDialog';
import messages from 'containers/ApplicationFormPage/messages';
import { FormattedMessage } from 'react-intl';



import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import { timelineItemClasses } from '@material-ui/lab/TimelineItem';
import  { useEffect, useState } from 'react';

// const pmc_link = 'https://mobileapp.primehealth.ae:5040/preinsuweb/Prime_PreInsuranceAppointment'//'https://preinsurance.primehealth.ae:5055/Prime_Clientregistration';
// const manzil_link = 'https://lab.manzil.health/';

const useStyles = makeStyles(theme => ({
  container: {
    maxWidth: '660px',
  },
  link: {
    'text-decoration': 'underline',
  },
  disabled: {
    color: '#B6B8B4',
  },
  primary: {
    color: theme.palette.primary.dark,
  },
  timelinedot: {
    width: 15,
    height: 15
  }
}));

const isEmptyObject = flow(values, compact, isEmpty);

export default function Section(props) {
  const classes = useStyles();
  
  const { isEcg, parties, agencyCountryCode } = props;

  const [dialogManzil, setDialogManzil] = useState(false);
  const [dialogPmc, setDialogPmc] = useState(false);
  const getMedicalJourneyText =  () => {

    const clinicVisitContent = (<>
      <div style={{ marginTop: '10px' }}>
        <FormattedMessage {...messages.clinicVisitSubmitApplicationMsg} />
      </div>
      <div style={{ marginTop: '10px' }}>
        <Typography>
          <u><FormattedMessage {...messages.toBookTheMedicalAppointment} /></u>
        </Typography>
        <Typography>
          <ul style={{ listStyleType: 'disc' }}>
            <li>
              Check the <b><Link
                target="_blank"
                href={agencyCountryCode === 'AE' ? pdfUaeLink : pdfBahQarLink}
                underline="always"
                color="inherit"
              >attached clinic list</Link> </b> to find a clinic that’s convenient for the customer.
            </li>
            <li>
              Use the policy number to book an appointment at a clinic from this list.
            </li>
          </ul>
        </Typography>
      </div>
    </>)
    if (!isEcg && agencyCountryCode === "AE") {
      return (
        <>
            <div style={{ marginTop: '10px' }}>
              <FormattedMessage {...messages.clinicVisitSubmitApplicationMsg} />
            </div>
            <ul style={{ listStyleType: 'disc' }}>
              <li>
                If the customer is in <span style={{ fontWeight: "700" }}>Dubai, Sharjah,</span> or <span style={{ fontWeight: "700" }}>Ajman,</span> you can book an appointment with:

                <ul style={{ listStyleType: 'circle' }}>
                  <li>
                    <Link
                      href="#"
                      onClick={e => {
                        e.preventDefault();
                        setDialogPmc(true);
                      }}
                      color="inherit"
                      variant="body3"
                      //underline="none"
                      className={classes.link}
                    > Prime Homecare</Link>{/* &nbsp;<Link
                  href="#"
                  onClick={() => {
                    window.open(pmc_link, "_blank", "noreferrer");
                  }} 
                  color="inherit"
                  variant="body3" 
                  className={classes.link}
                >
                  Prime Homecare
              </Link> or  */}
                    &nbsp; or <Link
                      href="#"
                      // onClick={() => {
                      //   window.open(manzil_link, "_blank", "noreferrer");
                      // }} 
                      onClick={e => {
                        e.preventDefault();
                        setDialogManzil(true);
                      }
                      }
                      color="inherit"
                      variant="body3"
                      className={classes.link}
                    >
                      Manzil Home Health
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                If the customer is in <span style={{ fontWeight: "700" }}>any other Emirate,</span> book your appointment with
                &nbsp;<Link
                  href="#"
                  // onClick={() => {
                  //   window.open(manzil_link, "_blank", "noreferrer");
                  // }} 
                  onClick={e => {
                    e.preventDefault();
                    setDialogManzil(true);
                  }
                  }
                  color="inherit"
                  variant="body3"
                  className={classes.link}
                >Manzil Home Health.</Link>
              </li>
            </ul>
          </>
      );
    }

    return <>{clinicVisitContent}</>
  }

  const getMedicalDescText = (parties) => {
    const nameList = parties
      .filter(({ underwriting }) => !isEmpty(underwriting.enhancedMedicalParam))
      .map(({ firstName, lastName }) => `${firstName} ${lastName}`);

    const clinicVisitContent =
      (nameList.length === 1 && parties.length > 1) ? (
        <>
          {nameList[0]} <FormattedMessage {...messages.clinicVisitMessage1} />
        </>
      ) : (
        <FormattedMessage {...messages.clinicVisitMessage} />
      );

    if (!isEcg && agencyCountryCode === "AE") {
      return (
        <b>
          <FormattedMessage {...messages.ohmsNoClinicVisitMessage} />
        </b>
      );
    }
    return <b>{clinicVisitContent}</b>;
  };
  
  return (
    <>
      <Grid item>
        <Typography variant="body1" color="primary">

          <Timeline align="left">
            <TimelineItem >
              <TimelineOppositeContent style={{flex: 0, display: 'none' }} />
              <TimelineSeparator ><TimelineDot style={{backgroundColor: "#EA635C"}} className={classes.timelinedot}/><TimelineConnector style={{backgroundColor: "#EA635C"}}/></TimelineSeparator>
              <TimelineContent>
                <Typography>
                  <FormattedMessage {...messages.medicalTestNeededForApplication} />
                </Typography>
                <Typography>
                  {getMedicalDescText(parties)}
                </Typography>
                  <Typography>
                   {parties && (parties.length === 2 ? <FormattedMessage {...messages.listOfMedicalTestRequired2} /> : <FormattedMessage {...messages.listOfMedicalTestRequired1} /> )}
                  </Typography>
                  <Typography>
                  <div style={{display: "grid",gridTemplateColumns: "repeat(2, 1fr)",gap: "60px",marginTop: "20px"}}>
                    {parties.map((party, index) => (
                      <div key={index}>
                        <div style={{fontWeight: "900",marginBottom: "16px",borderBottom: "1px solid #ddd",paddingBottom: "8px",}}>
                          {party.firstName} {party.lastName}
                        </div>

                        {isEmpty(party?.underwriting?.enhancedMedicalParam?.requirements) ? 
                          <div>
                            <FormattedMessage {...messages.uwAcceptedMedicalMsg} />
                          </div> : 
                          <ol style={{ paddingLeft: "20px", margin: 0 }}>
                            {party?.underwriting?.enhancedMedicalParam?.requirements?.map(
                              (req, i) => (
                                <li key={i} style={{ marginBottom: "12px",borderBottom: "1px solid #ddd",paddingBottom: "8px"}}>
                                  {req.value}
                                </li>
                              )
                            )}
                          </ol> 
                        }
                      </div>
                    ))}
                  </div>
                </Typography>
              </TimelineContent>
            </TimelineItem>

            <TimelineItem>
              <TimelineOppositeContent style={{flex: 0, display: 'none' }} />
              <TimelineSeparator><TimelineDot style={{backgroundColor: "#4066B3"}} className={classes.timelinedot}/> </TimelineSeparator>
              <TimelineContent>
                <Typography><b><FormattedMessage {...messages.nextSteps} /> </b></Typography>
                {getMedicalJourneyText()}
              </TimelineContent>
            </TimelineItem>
          </Timeline>
      
          <NoticeBox variant="withoutIcon">
              <p><b>Good to know:</b></p>
              <p>If your customer has already completed <b>Zurich medicals in the past 12 months</b>, this step won’t be needed. After underwriting review, we may request more information if needed. </p>
          </NoticeBox>
          
        </Typography>
      </Grid>

      <Dialog
        open={dialogManzil}
        onClose={() => {
          setDialogManzil(false);
        }}
        variant="info"
        //title="Send"
        actions={
          <Grid
            container
            alignItems="center"
            wrap="nowrap"
            justify="center"
            spacing={2}
          >

            <Grid item>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={() => {
                    window.open(api.manzil_link, "_blank", "noreferrer");
                }}
              >
                Continue
              </Button>
            </Grid>
          </Grid>
        }
      >
        <Typography variant="body1" style={{ fontWeight: 500 }}>
          You'll be redirected to <b><u style={{ fontWeight: 900 }}>Manzil Home Health's Website.</u></b> They'll handle your personal data in line with their Data Protection and Privacy policy.
        </Typography>
        <br />
        
      </Dialog>


      <Dialog
        open={dialogPmc}
        onClose={() => {
          setDialogPmc(false);
        }}
        variant="info"
        //title="Send"
        actions={
          <Grid
            container
            alignItems="center"
            wrap="nowrap"
            justify="center"
            spacing={2}
          >

            <Grid item>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={() => {
                    window.open(api.pmc_link, "_blank", "noreferrer");
                }}
              >
                Continue
              </Button>
            </Grid>
          </Grid>
        }
      >
        <Typography variant="body1" style={{ fontWeight: 500 }}>
          You'll be redirected to <b><u style={{ fontWeight: 900 }}>Prime Homecare's Website.</u></b> They'll handle your personal data in line with their Data Protection and Privacy policy.
        </Typography>
        <br />
        
      </Dialog>

      
    </>
  );
}
